import { NAV_LINKS, COMPANY } from "../data/content";
import { scrollToId } from "../lib/scroll";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="footer" className="border-t border-line">
      <div className="mx-auto max-w-[1400px] px-6 pt-16 lg:px-12">
        <div className="grid gap-12 pb-16 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <img
              src="/images/logo-3d.png"
              alt="Udat Marine logo"
              className="h-12 w-auto"
            />
            <p className="mt-5 max-w-xs text-sm font-light leading-relaxed text-steel">
              Shipping agency, salvage &amp; heavy lifting, and 24/7 marine port
              support from Pengerang, Johor — since 2001.
            </p>
            <a
              data-testid="footer-facebook-link"
              href={COMPANY.facebook}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-5 inline-block border border-line px-4 py-2 font-mono text-[10px] uppercase tracking-[0.2em] text-steel transition-colors hover:border-brand hover:text-brand"
            >
              Facebook
            </a>
          </div>

          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-steel">
              Explore
            </p>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <button
                    data-testid={`footer-link-${l.href.slice(1)}`}
                    onClick={() => scrollToId(l.href)}
                    className="text-sm text-slate-200 transition-colors hover:text-brand"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-steel">
              Departments
            </p>
            <ul className="mt-5 space-y-3">
              {COMPANY.emails.map((e) => (
                <li key={e.email} className="text-sm text-slate-200">
                  <span className="block text-xs text-steel">{e.dept}</span>
                  <a
                    href={`mailto:${e.email}`}
                    data-testid={`footer-email-${e.email.split("@")[0]}`}
                    className="transition-colors hover:text-brand"
                  >
                    {e.email}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-steel">
              Head Office
            </p>
            <p className="mt-5 text-sm leading-relaxed text-slate-200">
              {COMPANY.address}
            </p>
            <p className="mt-3 text-sm text-steel">
              {COMPANY.phoneOffice} · {COMPANY.phoneDuty}
            </p>
          </div>
        </div>
      </div>

      <div className="overflow-hidden px-2">
        <div className="text-outline-soft whitespace-nowrap text-center font-display text-[15vw] font-semibold uppercase leading-[0.8] tracking-tighter">
          Udat Marine
        </div>
      </div>

      <div className="border-t border-line">
        <div className="mx-auto flex max-w-[1400px] flex-col gap-2 px-6 py-5 font-mono text-[10px] uppercase tracking-[0.16em] text-steel sm:flex-row sm:items-center sm:justify-between lg:px-12">
          <span data-testid="footer-copyright">
            © {year} Udat Marine Sdn Bhd ({COMPANY.regNo})
          </span>
          <span>Pengerang · Johor · Malaysia</span>
        </div>
      </div>
    </footer>
  );
}
